<template>
  <VApp id="huntica-theme">
    <MenuDesktop
      v-if="$vuetify.breakpoint.smAndUp && showMenus"
    />
    <MenuMobile
      v-if="$vuetify.breakpoint.xs && showMenus"
    />
    <VSystemBar
      v-for="(notification) of unreadNotifications"
      :key="notification.id"
      height="53px"
      app
      absolute
      class="justify-center cyan lighten-5 text-center huntica-notification"
    >
      <span v-html="notification.record.text" />
      <VBtn icon @click="readMessage(notification)">
        <VIcon>
          mdi-close
        </VIcon>
      </VBtn>
    </VSystemBar>
    <VMain class="relative">
      <div class="mx-sm-7" style="height: 100% !important;" v-if="isNeedContainer">
        <VContainer style="height: 100% !important;">
          <slot />
        </VContainer>
      </div>
      <div class="mx-3 mx-md-4 mr-lg-4 ml-lg-7" v-else>
        <slot />
      </div>
    </VMain>
  </VApp>
</template>

<script>
import MenuDesktop from '../components/TheMenu/TheMenuDesktop.vue';
import MenuMobile from '../components/TheMenu/TheMenuMobile.vue';
import User from '../orm/models/User/User';
import Notification from '../orm/models/Notification/Notification';

export default {
  name: 'DefaultLayout',
  components: {
    MenuDesktop,
    MenuMobile,
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(routeName) {
        if (routeName !== 'notifications') {
          this.loadUserNotifications();
        }
      },
    },
  },
  computed: {
    user() {
      return User.getAuthUser();
    },
    showMenus() {
      if (this.$route.meta.showMenus === false) {
        return false;
      }

      if (this.user && this.user.createdUid) {
        return false;
      }

      return !!this.user;
    },
    showSystemBar() {
      return this.showVerifyEmailBar;
    },
    showVerifyEmailBar() {
      return this.user && !this.user.emailVerified;
    },
    isNeedContainer() {
      return !['candidates', 'candidate'].includes(this.$route.name) && !['payment', 'settings'].includes(this.$route.name) && !['order'].includes(this.$route.name);
    },
    unreadNotifications() {
      return Notification.query().where('read', false).all();
    },
  },
  methods: {
    loadUserNotifications() {
      Notification.api().getUserNotifications();
    },
    readMessage(notification) {
      Notification.api().markAsRead(notification.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.skew-bg {
  position: relative;
  min-height: 100vh;

  &__content {
    position: relative;
    z-index: 1;
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    height: 80vh;
    min-height: 650px;
    transform: skewY(-7deg);
    transform-origin: 0 100%;
    z-index: 0;
  }
}
.v-application .v-system-bar.huntica-notification {
  border-bottom: 1px solid;
  border-bottom-color: #c4c4c4 !important;
}

.container {
  @media (min-width: 320px) {
    max-width: 100% !important;
  }
}
</style>

<style lang="scss">
.menu-icon {
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin-right: 10px;
}
.close .menu-icon {
  margin: 0 auto;
  display: flex;
}
.v-application .v-system-bar.huntica-notification p {
  margin-bottom: 0;
}
</style>
